import { SitesetupConfiguration } from './config/sitesetup_configuration';

angular
  .module('capability-ng-sitesetup', [
    'ngSanitize',
    'ngAria',
    'ngMessages',
    'ngAnimate',
    'ct.ui.router.extras.core',
    'ct.ui.router.extras.dsr',
    'ct.ui.router.extras.sticky',
    'vendor'
  ])
  .run((ngSitesetupConfiguration: SitesetupConfiguration) => {
    ngSitesetupConfiguration.configureCapability({
      configUrl: 'config/'
    });
  });



// WEBPACK FOOTER //
// ./app/lib/sitesetup/core.ts